import React from "react";

export default function Dishes() {
  return <div>Dishes</div>;
}
